import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Clip icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Clip } from '@sravni/design-system-icons'
 *
 * <Clip />
 * ```
 */
var Clip = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Clip", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m16.742 9.759-6.565 6.564a4.288 4.288 0 0 1-6.064-6.064l6.564-6.565a2.859 2.859 0 1 1 4.043 4.043L8.15 14.302a1.43 1.43 0 0 1-2.022-2.022l6.065-6.057", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Clip };
//# sourceMappingURL=Clip.js.map
